import { memo, useContext } from "react";
import PropTypes from "prop-types";
import Typography, { TYPOGRAPHY_VARIANTS } from "app/pages/.shared/Typography/Typography";
import { Amount } from "app/components/ui/Amount/Amount";
import { FormattedMessage } from "react-intl";
import Paragraphs from "app/pages/.shared/Paragraphs";
import "./MerchandisingMediasIntro.scss";
import { Button } from "app/components/ui/Button/Button";
import { scrollToElement } from "app/utils/scroller";
import AppGlobalsContext from "app/AppGlobalsContext";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import isEmpty from "lodash/isEmpty";
import { ArrowDownwardIcon } from "app/icons/navigation";

const MerchandisingMediasIntro = ({ mediaIntroduction = {}, fromPrice, scrollTargetRef }) => {
	const { title = "", description } = mediaIntroduction;
	const { resolution } = useContext(AppGlobalsContext);
	const isMobile = resolution === RESOLUTION.SMALL || resolution === RESOLUTION.MEDIUM;
	const handleClick = () => {
		scrollToElement({
			element: scrollTargetRef?.current,
			disableSmoothScroll: false,
		});
	};
	return (
		title &&
		!isEmpty(description) && (
			<div className="merchandising-medias-intro">
				<div className="merchandising-medias-intro__title">
					<Typography
						variant={TYPOGRAPHY_VARIANTS.XL7}
						variantMD={TYPOGRAPHY_VARIANTS.XL9}
						isBold
						className="merchandising-medias-intro__title-label"
						data-testid="merchandising-medias-intro-title-label"
						component="h1"
					>
						{title}
					</Typography>
					{fromPrice > 0 && (
						<Amount value={fromPrice} from perPerson size="xl2" sizeMD="xl4" />
					)}
				</div>
				{isMobile && (
					<div className="merchandising-medias-intro__button">
						<Button
							variant="secondary"
							size="lg"
							endIcon={<ArrowDownwardIcon />}
							onClick={handleClick}
						>
							<FormattedMessage id="listing.filter.menu.cta.label" />
						</Button>
					</div>
				)}
				<div className="merchandising-medias-intro__description">
					<Typography
						variant={TYPOGRAPHY_VARIANTS.LARGE}
						variantMD={TYPOGRAPHY_VARIANTS.XL}
						isBold
						className="merchandising-medias-intro__description-content"
						data-testid="merchandising-medias-intro-description-content"
					>
						<Paragraphs paragraphs={description} enableHTMLFormatting />
					</Typography>
					<div />
				</div>

				{!isMobile && (
					<div className="merchandising-medias-intro__button">
						<Button
							variant="secondary"
							size="lg"
							endIcon={<ArrowDownwardIcon />}
							onClick={handleClick}
						>
							<FormattedMessage id="listing.filter.menu.cta.label" />
						</Button>
					</div>
				)}
			</div>
		)
	);
};

MerchandisingMediasIntro.propTypes = {
	mediaIntroduction: PropTypes.object,
	fromPrice: PropTypes.number,
	scrollTargetRef: PropTypes.object,
};

export default memo(MerchandisingMediasIntro);
